export default __webpack_public_path__ + "static/media/Inconsolata-Light.3fc99390.ttf";